import React from 'react';
import PageBanner from "../../components/sections/front/PageBanner";
import Image from "../../components/elements/Image";
import Image1 from '../../assets/images/testimonial1.png';
import TestimonialOverview from "../../components/sections/front/TestimonialOverview";

const Banner = {
  title: "Our Testimonials",
  description: "Hear what our clients and partners have to say about their experience working with Trihurst Tech, and how our solutions have helped them grow, innovate, and build lasting success.",
};

const TestimonialOverviewDetails = {
    subTitle: "CUSTOMER REVIEWS",
    title: "Reviews from our users",
    description: "From smooth onboarding to outstanding results, see how our platform is making a real difference in the lives of people and businesses just like yours—helping them grow faster, work smarter, and achieve lasting success every day with reliable support and innovative features. At Trihurst Tech, we don’t just provide tools—we build experiences that empower you at every step.",
    image : Image1,
    icon : "fa-solid fa-star",
    rating: "5 out of 5 stars",
    reviewsCount: "average rating from 94,192 reviews",
    reviewer: {
      name: "Emily Johnson",
      position: "CEO of Stripe",
    },
}

const Testimonial = () => {
  return (
    <>
      <PageBanner data={Banner} />
      <TestimonialOverview data={TestimonialOverviewDetails }/>
    </>
  )
}

export default Testimonial